import { createDetailReducer } from '../../common/services/reducerCreator';

export const matchTeamReducer = createDetailReducer({
  modelName: 'MATCHTEAM',
});
